import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const schemaItems = items.map((item, idx) => ({
    '@type': 'ListItem' as const,
    position: idx + 1,
    item: item.href
      ? { '@id': `${window.location.origin}${item.href}`, name: item.label }
      : { '@id': window.location.href, name: item.label },
  }));

  const ldJson = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(ldJson)}</script>
      <nav aria-label="面包屑导航" className="w-full max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-2">
        <ol className="flex items-center gap-1 text-xs text-foreground-500 flex-wrap">
          {items.map((item, idx) => (
            <li key={idx} className="flex items-center gap-1">
              {idx > 0 && (
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-xs text-foreground-300"></i>
                </div>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium whitespace-nowrap">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}